<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.products.enhance.title") }}
    </h4>
    <form @submit.prevent>
      <div class="row">
        <div class="col-6 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.family')}}</label>
          <div class="col-12">
            <el-select
              class="select-primary"
              size="large"
              filterable
              clearable
              placeholder="Producto Padre"
              v-model="productoPadreId"
              value=""
            >
              <el-option
                class="select-primary"
                v-for="padre in padres"
                :value="padre['idFamiliaProducto']"
                :label="padre['productoPadre']"
                :key="padre['productoPadre']"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-6 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.sapCode')}}</label>
          <label class="col-form-label col-12">{{codigoSap}}</label>
          <!--div class="col-12">
            <input type="text" class="form-control" v-model="codigoSap">
          </div-->
        </div>
        <div class="col-12 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.sapDescription')}}</label>
          <label class="col-form-label col-12">{{textoSap}}</label>
          <!--div class="col-12">
            <input type="text" class="form-control" v-model="textoSap">
          </div-->
        </div>
        <div class="col-12 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.clientDescES')}}</label>
          <div class="col-12">
            <textarea class="form-control" rows="3" v-model="textoClienteSP"></textarea>
          </div>
        </div>
        <div class="col-12 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.clientDescEN')}}</label>
          <div class="col-12">
            <textarea  class="form-control" rows="3" v-model="textoClienteEN"></textarea>
          </div>
        </div>
        <div class="col-4 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.packed')}}</label>
          <div class="col-12">
            <el-select
              class="select-primary"
              size="large"
              filterable
              clearable
              placeholder="Tipo Empaquetado"
              v-model="tipoEmpaquetado"
              value=""
            >
              <el-option
                class="select-primary"
                v-for="tipo in tipoEmpaquetados"
                :value="tipo.key"
                :label="tipo.text"
                :key="tipo.text"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-4 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.published')}}</label>
          <div class="col-12">
            <n-switch v-model="published">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-4 form-group">
          <label class="col-form-label col-12">{{$t('app.modules.products.labels.enhanced')}}</label>
          <div class="col-12">
            <n-switch v-model="enhanced">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-12">
          <h4>{{$t('app.modules.products.labels.addCaract')}}</h4>
        </div>
        <div class="col-md-5 col-12 form-group">
          <el-select
            class="select-primary"
            size="large"
            filterable
            clearable
            placeholder="Caracteristica"
            v-model="selectedCaracteristica"
            value=""
          >
            <el-option
              v-for="caract in caracteristicas"
              :value="caract.key"
              :label="caract.txt"
              :key="caract.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-4 col-12 form-group">
          <el-select
            class="select-primary"
            size="large"
            filterable
            clearable
            placeholder="Valor"
            :readonly="selectedCaracteristica == null"
            :disabled="selectedCaracteristica == null"
            value=""
            v-model="selectedVal"
          >
            <el-option
              v-for="(val, key) in selectedVals"
              :value="key"
              :label="val"
              :key="key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-2  col-12 form-group">
          <div class="col-12">
            <button class="btn like btn-icon btn-round btn-primary btn-md mt-0" @click="addCaracteristicas()"><i class="now-ui-icons ui-1_simple-add"></i></button>
          </div>
        </div>
        <div class="col-md-12">
          <table class="table">
            <thead>
            <tr>
              <th scope="col">{{$t('app.modules.products.labels.feature')}}</th>
              <th scope="col">{{$t('app.modules.products.labels.value')}}</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(caracteristica, index) in caracteristicasProducto">
              <td>{{ caracteristica.caractName }}</td>
              <td>{{ caracteristica.valName }}</td>
              <td><a class="btn btn-icon btn-sm btn-danger" @click="quitCaracteristica(index)"><i class="fa fa-trash text-light"></i></a></td>
            </tr>
            <tr v-if="!caracteristicasProducto || !caracteristicasProducto.length">
              <td colspan="3" class="text-center text-muted font-italic">{{$t('app.modules.products.details.noFeaturesAdded')}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        slot="footer"
        style="margin-top: 10px; padding-top: 20px;border-top: outset;"
        class="text-right"
      >
        <n-button class="pull-left" @click.native="cancelAdd()">{{$t('app.modules.products.buttons.cancel')}}</n-button>
        <n-button native-type="submit" type="primary" @click.native="handleSubmit()">{{$t('app.modules.products.buttons.save')}}</n-button>
      </div>
    </form>
  </modal>
</template>

<script>
import {getResponse} from "@/util/utilities";

export default {
  name: "ProductEnhance",
  data(){
    return{
      idProducto: 0,
      padres:{},
      modals: {
        classic: false
      },
      product: [],
      codigoSap: null,
      textoSap: null,
      textoClienteSP: null,
      textoClienteEN: null,
      caracteristicas: [],
      productoPadreId: "",
      enhanced: true,
      published: false,
      selectedCaracteristica: null,
      selectedVals: [],
      caracteristicasProducto: [],
      selectedVal: null,
      tipoEmpaquetado: null,
      tipoEmpaquetados:{0:{key: 1, text: "Empaquetado"}, 2:{key: 2, text: "Granel"}}
    }
  },
  mounted() {
    EventBus.$on("product-enhance", async idProducto => {
      await this.init(idProducto);
    });
  },
  methods:{
      async init(idProducto){
      this.idProducto = idProducto;
      this.selectedCaracteristica = null;
      this.selectedVal = null;
      this.showLoader();
      await this.getFamilias();
      await this.getCaracteristicas();
      await this.getProducto(idProducto);
      this.closeLoader();
      this.modals.classic = true;
    },
    showLoader() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
    },
    closeLoader(){
      this.$swal.close();
    },
    async handleSubmit() {
      try {
        debugger;
        if (!this.productoPadreId) {
          throw new Error(this.$t("app.modules.products.enhance.fam_error"));
        }
        if (!this.tipoEmpaquetado) {
          throw new Error(this.$t("app.modules.products.enhance.packed_error"));
        }
        const params = {
          idProducto: this.idProducto,
          TextoBreveMaterial: this.textoSap,
          Material: this.codigoSap,
          FamiliaProductos_idFamiliaProducto: this.productoPadreId,
          DescripcionClienetES: this.textoClienteSP,
          DescripcionClienetEN: this.textoClienteEN,
          Publicado: this.published,
          Enriquecido: this.enhanced,
          Caracteristicas: this.caracteristicasProducto,
          tipoEmpaque: this.tipoEmpaquetado
        };
        this.showLoader();
        let productoRequest = await this.$http.put(route("Productos/UpdateProductInfo"), params)
        let code = getResponse(productoRequest, null, body => body.code);
        if (code == 200) {
          this.notifyMessage("success", this.$t("app.promps.save_success"));
          this.modals.classic = false;
          EventBus.$emit("product-enhance-success");
        } else {
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
      } catch (e) {
        console.error(e);
        this.notifyMessage("danger", e.message);
      }
      this.closeLoader();
    },
    cancelAdd(){
      this.modals.classic = false;
    },
    async getFamilias(){
      this.padres = [];

      try {
        let familiasRequest = await this.$http.get(route("familiasProducto/getFamiliasProducto"))

        let familias = getResponse(familiasRequest, null, body => body.familiasProductos);
        familias = familias || [];

        this.padres = familias;
      } catch (e) {
        console.error(e);
      }
    },
    async getCaracteristicas(){
      this.caracteristicas = [];

      try {
        let request = await this.$http.get(route("CaracteristicasProducto/getCaratacteristicasProducto"))

        let caracteristicas = getResponse(request, null, body => body.caracteristicasProducto);
        caracteristicas = caracteristicas || [];
        this.handleCaracteristicas(caracteristicas);
      } catch (e) {
        console.error(e);
      }
    },
    async getProducto(id){
      const params = {
        idProducto: id
      };
      try {
        let productoRequest = await this.$http.post(route("Productos/getInformacionProducto"), params)

        let producto = getResponse(productoRequest, null, body => body.producto);
        producto = producto || null;

        this.producto = producto;
        this.handleProduct(this.producto);
      } catch (e) {
        console.error(e);
      }
    },
    handleProduct(productoArray){

      this.codigoSap = productoArray['material'];
      this.textoSap = productoArray['textoBreveMaterial'];
      this.productoPadreId = productoArray['familiaProductos_idFamiliaProducto']?productoArray['familiaProductos_idFamiliaProducto']:null;
      this.tipoEmpaquetado = productoArray['tipoEmpaque']?productoArray['tipoEmpaque']:null;
      this.textoClienteSP = productoArray['descripcionClienetES'];
      this.textoClienteEN = productoArray['descripcionClienetEN'];
      this.published = productoArray['publicado'];
      this.caracteristicasProducto = [];
      this.selectedVals = [];
      var caracts = productoArray['caracteristicas'];
      if(caracts && caracts.length){
        caracts.forEach(cat => {
          var catName = this.findCaractName(cat.idCaracteristicasProducto);
          var valName = this.findValName(cat.idCaracteristicasProducto, cat.valorCaracteristica);
          this.pushToCats(cat.idProductoCaracteristicas, cat.idCaracteristicasProducto,catName, cat.valorCaracteristica,valName)
        });
      }
      this.enhanced = true;
    },
    handleCaracteristicas(caracteristicasArray){
      var selected_lang = 3;
      if(caracteristicasArray){
        var traducciones = [];
        caracteristicasArray.forEach(element =>{
          if(element.activo){
            traducciones = element.traduccion;
            var key = 0;
            var txt = '';
            var values = [];
            var current_lang_trads = traducciones.filter(it => {
              return it.idiomas_idIdioma == selected_lang;
            });
            if(!current_lang_trads.length){
              current_lang_trads = traducciones.filter(it => {
                return it.idiomas_idIdioma == 1
              });
            }
            if(current_lang_trads){
              key = element.idcaracteristicasProducto;
              txt = current_lang_trads[0].nombreAtributo;
              values = JSON.parse(current_lang_trads[0].valorAtributo);
              this.caracteristicas.push({key: key, txt: txt, values: values});
            }
          }
        });
      }
    },
    pushToCats(id, idCat, catName, val, valName){
      this.caracteristicasProducto.push({
        idProductoCaracteristicas: id,
        idCaracteristicasProducto: idCat,
        caractName: catName,
        valorCaracteristica: val,
        valName: valName});

    },
    addCaracteristicas(){
      if(this.selectedCaracteristica && this.selectedVal){
        console.log(this.selectedCaracteristica);
        var inCaractArr = this.caracteristicasProducto.filter(it => {return it.idCaracteristicasProducto == this.selectedCaracteristica});
        if(!this.caracteristicasProducto.length || !inCaractArr.length){
          var caractName = this.findCaractName(this.selectedCaracteristica);
          var valName = this.findValName(this.selectedCaracteristica, this.selectedVal);
          this.pushToCats(0, this.selectedCaracteristica, caractName, this.selectedVal, valName);
          this.selectedCaracteristica = null;
          this.selectedVal = null;
        }else{
          this.notifyMessage("danger", "Esta caracteristica ya fué agregada");
        }
      }else{
        this.notifyMessage("danger", "Debes seleccionar una caracteristica y su valor");
      }
    },
    quitCaracteristica(index){
        this.caracteristicasProducto.splice(index, 1);
    },
    findCaractName(key){
      var selectedCaractArr = this.caracteristicas.filter(it => {return it.key == key});
      var caractName = selectedCaractArr[0].txt;
      return caractName;
    },
    findValName(caractKey, valKey){
      var selectedCaracteristicaArray = this.caracteristicas.filter(function (it){
        return it.key === caractKey;
      });
      var selectedVals = selectedCaracteristicaArray[0].values;
      return selectedVals[valKey];
    }
  },
  filters: {
    product(value, prop = null)
    {
      let row = value;
      if (!!row)
      {
        let product = row;
        if (!!product && !!prop)
        {
          return product[prop];
        }

        return product;
      }
      return null;
    }
  },
  watch: {
    selectedCaracteristica: function(val) {
      if(val){
        var selectedCaracteristicaArray = this.caracteristicas.filter(function (it){
          return it.key === val;
        });
        this.selectedVals = selectedCaracteristicaArray[0].values;
      }else{
        this.selectedCaracteristica = null;
        this.selectedVals = [];
      }
    }
  }
};
</script>

<style scoped>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
